import { render, staticRenderFns } from "./ToplamB2BSiparisTutari.vue?vue&type=template&id=359eba57&scoped=true"
import script from "./ToplamB2BSiparisTutari.vue?vue&type=script&lang=js"
export * from "./ToplamB2BSiparisTutari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359eba57",
  null
  
)

export default component.exports